<router-outlet></router-outlet>
<p-toast position="bottom-right"></p-toast>
<app-loader></app-loader>
